import { useCallback } from 'react';
import { HowItWorks } from 'shared/landingSeller/components/HowItWorks';
import { useWithModalForm } from 'shared/common/hooks/useWithModalForm';
import { useApplicationContext } from 'shared/common/utils/applicationContext';
import { useVisibilityTracking } from 'shared/common/hooks/useVisibilityTracking';
import { showAgentCommissionBlock } from 'shared/landingSeller/components/tracking';

export const HowItWorksContainer: React.FC = () => {
  const { handleOpenModal } = useWithModalForm();
  const { custom } = useApplicationContext();
  const { cianUserId, source } = custom;

  const handleAgentCommissionVisible = useCallback(() => {
    showAgentCommissionBlock(custom);
  }, [custom]);

  const visibilityRef = useVisibilityTracking({
    onVisible: handleAgentCommissionVisible,
    threshold: 0.5,
    once: true,
  });

  return (
    <HowItWorks onOpenModal={handleOpenModal} userId={cianUserId} source={source} agentCommissionRef={visibilityRef} />
  );
};
